import { animate } from "@theme/animation";
import { ThemeEvents } from "@theme/events";
import { prefersReducedMotion } from "@theme/utilities";

class PageTransition extends HTMLElement {
  constructor() {
    super();

    // Skip the fade entirely if we arrived via a flagged link (any link with [data-skip-page-transition]).
    if (sessionStorage.getItem("skipPageTransition") === "1") {
      sessionStorage.removeItem("skipPageTransition");
      this.hidden = true;
      return;
    }

    // Delegate-listen for clicks on flagged links and stash the flag before navigation.
    document.addEventListener("click", (event) => {
      const link = event.target.closest("a[data-skip-page-transition]");
      if (link) sessionStorage.setItem("skipPageTransition", "1");
    });

    window.addEventListener("beforeunload", () => {
      document.body.classList.add("page-loading");
      document.dispatchEvent(
        new CustomEvent(ThemeEvents.pageTransitionStart, {
          bubbles: true,
          detail: { direction: "out", timestamp: Date.now() },
        })
      );
    });

    // Safari 15: Module scripts may load after DOMContentLoaded has fired
    // Check readyState and run immediately if DOM is already ready
    const initOnLoad = () => {
      document.dispatchEvent(
        new CustomEvent(ThemeEvents.pageLoaded, {
          bubbles: true,
          detail: { timestamp: Date.now() },
        })
      );
      this.hide();
    };

    if (document.readyState === "loading") {
      // DOM is still loading, wait for DOMContentLoaded
      window.addEventListener("DOMContentLoaded", initOnLoad, { once: true });
    } else {
      // DOM is already ready (interactive or complete), run immediately
      initOnLoad();
    }

    window.addEventListener("pageshow", (event) => {
      if (event.persisted) {
        document.body.classList.remove("page-loading");
      }
    });
  }

  hide() {
    const duration = prefersReducedMotion() ? 0 : 1;
    const finish = () => {
      this.hidden = true;
      document.dispatchEvent(
        new CustomEvent(ThemeEvents.pageTransitionEnd, {
          bubbles: true,
          detail: { timestamp: Date.now() },
        })
      );
    };
    animate(this, { opacity: 0 }, { duration, allowWebkitAcceleration: true }).finished.then(finish).catch(finish);
  }
}

if (!customElements.get("page-transition")) {
  customElements.define("page-transition", PageTransition);
}
